import { Spinner } from 'react-bootstrap';
import { CenterAligner } from '../../styles';

interface ILoading {
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

const Loading = ({ className }: ILoading) => {
  const c = `w-100 h-100 d-flex flex-column ${className ?? ''}`;
  return (
    <CenterAligner className={c}>
      <h1 className="m-0-important">Carregando...</h1>
      <br />
      <Spinner animation="border" variant="primary" />
    </CenterAligner>
  );
};

export default Loading;
